import React, { useState } from 'react'
import { StripePaymentEventDto } from '../../api/dto/invoice-delivery.dto'
import { formatCompactDate } from './utils'
import { resolveStripeEventDisplay } from './paymentStatus'
import {
  DrawBySubCompanyEventBy,
  DrawBySubCompanyEventError,
  DrawBySubCompanyEventLabel,
  DrawBySubCompanyEventList,
  DrawBySubCompanyEventRow,
  DrawBySubCompanyEventSection,
  DrawBySubCompanyEventTime,
  DrawBySubCompanyEventToggle,
  DrawBySubCompanyEventToggleIcon,
  DrawBySubCompanyEventTopRow,
} from './InvoiceDeliveryDrawer.styles'

interface StripePaymentEventHistoryProps {
  events: StripePaymentEventDto[] | null | undefined
}

/** Only the "created" event carries who initiated the draw. */
const TRIGGERED_BY_EVENT_TYPE = 'payment_intent.created'

/** Only the "payment_failed" event carries Stripe's last payment error. */
const PAYMENT_FAILED_EVENT_TYPE = 'payment_intent.payment_failed'

/** Collapsible "Stripe event history" footer for a DrawBySubCompanyCard. */
const StripePaymentEventHistory: React.FC<StripePaymentEventHistoryProps> = ({
  events,
}) => {
  const [open, setOpen] = useState(false)
  const list = events ?? []

  if (list.length === 0) return null

  return (
    <DrawBySubCompanyEventSection>
      <DrawBySubCompanyEventToggle
        type="button"
        onClick={() => setOpen((prev) => !prev)}
      >
        Stripe Event History ({list.length})
        <DrawBySubCompanyEventToggleIcon>
          {open ? '▲' : '▼'}
        </DrawBySubCompanyEventToggleIcon>
      </DrawBySubCompanyEventToggle>

      {open && (
        <DrawBySubCompanyEventList>
          {list.map((event) => {
            const { label, tone } = resolveStripeEventDisplay(event.eventType)
            const paymentError =
              event.eventType === PAYMENT_FAILED_EVENT_TYPE
                ? event.lastPaymentError
                : null
            return (
              <DrawBySubCompanyEventRow key={event.eventId}>
                <DrawBySubCompanyEventTopRow>
                  <span>
                    <DrawBySubCompanyEventLabel $tone={tone}>
                      {label}
                    </DrawBySubCompanyEventLabel>
                    {event.eventType === TRIGGERED_BY_EVENT_TYPE && (
                      <DrawBySubCompanyEventBy>
                        {' '}
                        (
                        {event.triggeredBy?.name
                          ? `by ${event.triggeredBy.name}`
                          : 'via Stripe Dashboard'}
                        )
                      </DrawBySubCompanyEventBy>
                    )}
                  </span>
                  <DrawBySubCompanyEventTime>
                    {formatCompactDate(event.eventCreatedAt)}
                  </DrawBySubCompanyEventTime>
                </DrawBySubCompanyEventTopRow>
                {paymentError?.message && (
                  <DrawBySubCompanyEventError>
                    {paymentError.message}
                  </DrawBySubCompanyEventError>
                )}
              </DrawBySubCompanyEventRow>
            )
          })}
        </DrawBySubCompanyEventList>
      )}
    </DrawBySubCompanyEventSection>
  )
}

export { StripePaymentEventHistory }
